<div class="resource-separator">
  <span> </span>
</div>
